import styled from '@xstyled/styled-components';
import { Widths, MOBILE_BREAKPOINT, BOXWIDTH } from '../../common/Constants';

const FeatureBaseButton = styled.button`
    display: block;
    width: 100%;
    padding: clamp(1px, 1vw, 5px) clamp(4px, 1vw, 15px); /* Gradually adjust padding based on viewport */
    margin-bottom: clamp(1px, 1vw, 5px);
    color: white;
    border: none;
    border-radius: clamp(0px, 1vw, 4px);
    cursor: pointer;
    text-align: left;
    transition: background-color 0.3s ease;
    font-size: clamp(4px, 1.5vw, 12px);

    @media (max-width: ${MOBILE_BREAKPOINT}px) {
        width: 78px; /* Set a fixed width for square buttons */
        display: flex; /* Center the content */
        align-items: center; /* Center the content vertically */
        justify-content: center; /* Center the content horizontally */
    }
`;

// #region Exported Styles
export const SideMenuContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: calc(100vh - 60px);
    min-width: 20vw;
    background-color: #f9f9f9;
    padding: clamp(1rem, 1vw, 10rem);
    border-right: 1px solid #ddd;
    overflow-y: auto;
    
    @media (min-width: ${Widths.WIDTH_1100}) {
        min-width: 220px;
        width: 220px;
    }
        
    @media (max-width: ${MOBILE_BREAKPOINT}px) { 
        min-width: 83px;
        padding: 0.2rem;
        height: calc(100vh - 60px - 60px);
    }

    @media (max-width: ${BOXWIDTH}) {
        max-width: 5vh;
    }
`;
export const AddNewCharacterButton = styled(FeatureBaseButton)`
    background-color: #4CAF50;
    font-size: clamp(12px, 2vw, 13px);
    &:hover {
        background-color: #45a049;
    }
    span {
        padding-left: clamp(1px, 1vw, 5px);
    }
`;
export const SummarizeButton = styled(FeatureBaseButton)`
    background-color: #72367C;
    color: white;
    font-size: clamp(11px, 2vw, 13px);
    &:hover {
        background-color: #888;
    }
    span {
        padding-left: clamp(1px, 1vw, 5px);
    }
`;
export const CopyConfigButton = styled(FeatureBaseButton)`
    background-color: #2196F3;
    font-size: clamp(12px, 2vw, 13px);
    &:hover {
        background-color: #1976D2;
    }
    span {
        padding-left: clamp(1px, 1vw, 5px);
    }
`;
export const PasteConfigButton = styled(FeatureBaseButton)`
    background-color: #2196F3;
    font-size: clamp(12px, 2vw, 13px);
    &:hover {
        background-color: #1976D2;
    }
    span {
        padding-left: clamp(1px, 1vw, 5px);
    }
`;
export const ResetConfigButton = styled(FeatureBaseButton)`
    background-color: #FF9800;
    font-size: clamp(12px, 2vw, 13px);
    &:hover {
        background-color: #F57C00;
    }
        span {
        padding-left: clamp(1px, 1vw, 5px);
        }
`;
export const FooterContainer = styled.div`  
    display: flex;
    flex-direction: column;
    flex-scrink: 0;
    align-items: center;
    justify-content: center;
    margin-top: clamp(1px, 1vw, 5px)
    ;
    width: 100%;
    color: white;
    padding-top: 1px solid #ccc;
    background-color: #999;
    margin-bottom: 20px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 4px;

    input[type="checkbox"] {
        transform: scale(0.8);
        margin-right: 3px;
        line-height: 2;
    }
        
    @media (max-width: ${MOBILE_BREAKPOINT}px) { 
        width: 78px; /* Set fixed width */
        padding: 2px 0px;
        margin-bottom: 5px;
        justify-content: center; /* Center content horizontally */
        align-items: center; /* Center content vertically */
        font-size: clamp(9px, 1vw, 18px);
    }
`;
export const FakeOptionContainer = styled.label`
        display: flex;
        align-items: center;
        font-size: clamp(7px, 2vw, 12px);
`;
export const VersionInfo = styled.div`
    font-size: clamp(3px, 2vw, 12px);
    color: white;
    text-align: center;    
`;

export const LoadingMessage = styled.div`
    background-color: white;
    padding: 20px;
    border-radius: 4px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    text-align: center;
    color: black;
    font-size: 12px;
    margin: 10px;
`;
export const ScrollableCharactersContainer = styled.div`
    flex-grow: 1;
    overflow-y: auto;
    margin-bottom: 1rem;
`;

export const LoadingDiv = styled.div`
    display: flex;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
`;
// #endregion Exported Styles
